var exports = {
  "ei": "xcc377c0b--564b19--aside-builders-contacts",
  "Uo": "xcc377c0b--564b19--buttons",
  "MY": "xcc377c0b--564b19--action-button",
  "hR": "xcc377c0b--564b19--message-button",
};

module.exports = exports;
